<template>
	<div class="step-question">
		<v-flex>
			<v-layout align-center>
				<v-flex xs6 lg4 ml-3 text-xs-left class="title-question">
					<p class="ma-0" v-html="question"></p>
				</v-flex>
				<v-flex text-xs-right>
					<v-btn
						class="btn-auto btn-selected"
						:class="{'active' : showOne }"
						type="button"
						@click="open('showOne', 'showTwo')"
					>
						?
					</v-btn>
				</v-flex>
			</v-layout>
			<v-layout mt-4 class="layout">
				<div
					class="triangle"
					:class="{ 'active-two' : showTwo }"
				></div>
				<v-flex xs12 class="message-box">
					<v-flex v-if="showOne">
						<v-layout row justify-space-between align-center>
							<v-flex>
								<v-layout column>
									<v-flex class="title-integration">
										<p class="ma-0" v-html="acceptTitle"></p>
									</v-flex>
									<v-flex class="description" mt-3>
										<p class="ma-0" v-html="acceptDescription"></p>
									</v-flex>
								</v-layout>
							</v-flex>
							<v-flex>
								<v-flex class="video">
									<img class="img-source" :src="'/static/img/imgconta2.jpeg'" alt="img-conta">
								</v-flex>
							</v-flex>
						</v-layout>
						<v-layout row wrap mt-3 class="step-bottom">
							<v-flex xs12 sm5 class="step-bottom__col">
							<v-flex xs12 mb-3 class="title-warehouse">
								Seleccionar una empresa
							</v-flex>
							<v-flex xs12>
								<v-menu
									class="step-company-menu-wrap"
									offset-y
									nudge-bottom="6"
									max-height="340"
									min-width="300"
									content-class="step-company-menu"
									transition="slide-y-transition"
									:disabled="$route.meta.noChangeCompany"
								>
									<button
										slot="activator"
										type="button"
										class="step-company-pill"
										:title="currentSubsidiary.name || 'Seleccione una empresa'"
										:class="{ 'step-company-pill--empty': !currentSubsidiary.name }"
										:disabled="$route.meta.noChangeCompany"
									>
										<v-icon small class="step-company-icon" aria-hidden="true">business</v-icon>
										<span class="step-company-name">{{ currentSubsidiary.name || 'Seleccione una empresa' }}</span>
										<v-icon small class="step-company-caret" aria-hidden="true">expand_more</v-icon>
									</button>
									<v-list class="step-company-list" dense>
										<div v-if="limitReached" class="step-company-limit">
											<v-icon small aria-hidden="true">info</v-icon>
											<span>
												Tu plan permite {{ planLimit }} {{ planLimit === 1 ? 'empresa' : 'empresas' }}.
												Para llevar la contabilidad de otras, actualiza tu plan.
											</span>
										</div>
										<v-list-tile
											v-for="item in getGlobalSubsidiaries"
											:key="item.id"
											class="step-company-option"
											:class="{
												'step-company-option--active': Number(item.id) === Number(currentSubsidiary.id),
												'step-company-option--locked': !allowedIds.has(Number(item.id)),
											}"
											@click="selectSubsidiary(item.id)"
										>
											<v-icon small aria-hidden="true">{{ allowedIds.has(Number(item.id)) ? 'business' : 'lock' }}</v-icon>
											<span class="step-company-option-name">{{ item.name }}</span>
											<v-icon v-if="Number(item.id) === Number(currentSubsidiary.id)" small aria-hidden="true">check</v-icon>
										</v-list-tile>
										<v-list-tile v-if="!getGlobalSubsidiaries.length" class="step-company-option">
											<span class="step-company-option-name">No hay empresas disponibles</span>
										</v-list-tile>
									</v-list>
								</v-menu>
							</v-flex>
							</v-flex>
							<v-flex v-if="accountantCode" xs12 sm6 offset-sm1 class="step-bottom__col">
								<v-flex xs12 mb-3 class="title-warehouse">
									Código de contador
								</v-flex>
								<button
									type="button"
									class="step-code-pill"
									:class="{ 'step-code-pill--done': copied }"
									aria-label="Copiar código de contador"
									@click="copyAccountantCode"
								>
									<v-icon small class="step-code-icon" aria-hidden="true">{{ copied ? 'check_circle' : 'vpn_key' }}</v-icon>
									<span class="step-code-text">{{ copied ? 'Código copiado' : 'Copiar código de contador' }}</span>
									<v-icon small class="step-code-action" aria-hidden="true">content_copy</v-icon>
								</button>
								<p class="step-code-hint">Compártelo para anclar otras empresas a tu empresa contable.</p>
							</v-flex>
						</v-layout>
					</v-flex>
					<v-flex v-if="showTwo">
						{{ negativeTitle }}
					</v-flex>
				</v-flex>
			</v-layout>
		</v-flex>
		<v-dialog
			v-model="openDialog"
			persistent
			max-width="470"
		>
			<v-card class="dialog-contact">
				<v-btn
					class="btn-close btn-auto"
					depressed
					small
					@click="$emit('close-dialog')"
				>
					<span class="error--text">x</span>
				</v-btn>
				<v-flex mt-3 text-xs-center class="title-question">
					Para integrarte con quipu debes ir a la configuración de
				</v-flex>
			</v-card>
		</v-dialog>
		<section class="modal-filter-footer">
			<v-flex text-xs-center>
				<v-btn
					class="color-btn"
					color="btnFollowing"
					type="button"
					:disabled="disabledQuestion"
					@click.native="$emit('following-question')"
				>
					Siguiente
				</v-btn>
			</v-flex>
		</section>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import currentSubsidiaryStorage from '@/shared/current-subsidiary';

async function created() {
	const [remoteLimit] = await Promise.all([
		currentSubsidiaryStorage.fetchRemoteLimit(this.$http),
		this.$loadSubsidiaries({ context: this, params: {} }),
	]);
	this.remoteLimit = remoteLimit;
	// Una empresa fuera del límite del plan no puede quedar seleccionada.
	if (this.currentSubsidiary.id && !this.allowedIds.has(Number(this.currentSubsidiary.id))) {
		this.$setCurrentSubsidiary({});
	}
	const { subsidiaryId, subsidiaryName } = this.$route.params;
	if (subsidiaryId && subsidiaryName && this.allowedIds.has(Number(subsidiaryId))) {
		const id = Number(subsidiaryId);
		const currentSubsidiary = this.getGlobalSubsidiaries.find(sub => sub.id === id);
		this.$setCurrentSubsidiary(currentSubsidiary);
	} else if (this.getGlobalSubsidiaries.length === 1) {
		const currentSubsidiary = this.getGlobalSubsidiaries.find(sub => sub.companyId != null);
		this.$setCurrentSubsidiary(currentSubsidiary);
	} else if (!this.currentSubsidiary.id && this.limitReached && this.allowedIds.size === 1) {
		// El plan solo permite una empresa: queda seleccionada directamente.
		const [onlyId] = Array.from(this.allowedIds);
		this.selectSubsidiary(onlyId);
	}
}
function disabledQuestion() {
	return (this.showOne && !this.currentSubsidiary.id);
}

// Empresas que el plan permite usar (las más antiguas hasta subsidiaries_limit).
function allowedIds() {
	return currentSubsidiaryStorage.allowedIds(
		this.getGlobalSubsidiaries, this.$userInfo, this.remoteLimit);
}

function planLimit() {
	return currentSubsidiaryStorage.planLimit(this.$userInfo, this.remoteLimit);
}

function limitReached() {
	return this.planLimit !== null && this.getGlobalSubsidiaries.length > this.planLimit;
}

function selectSubsidiary(id) {
	if (!this.allowedIds.has(Number(id))) {
		this.showNotification(
			`Tu plan permite ${this.planLimit} ${this.planLimit === 1 ? 'empresa' : 'empresas'}. Actualiza tu plan para llevar la contabilidad de otras.`,
			'warning',
		);
		return;
	}
	const subsidiary = this.getGlobalSubsidiaries
		.find(item => Number(item.id) === Number(id));
	if (subsidiary) {
		this.$setCurrentSubsidiary(subsidiary);
	}
}

// Código de contador: com_companies.code de la empresa contable. Es el que usa
// POST /company/{codeAccountant}/affiliate para anclar otras empresas a ella.
function accountantCode() {
	const user = typeof this.$userInfo === 'string' ? JSON.parse(this.$userInfo) : this.$userInfo;
	const company = (user && user.company) || {};
	return company.code || '';
}

async function copyAccountantCode() {
	const code = this.accountantCode;
	try {
		if (navigator.clipboard && window.isSecureContext) {
			await navigator.clipboard.writeText(code);
		} else {
			const input = document.createElement('textarea');
			input.value = code;
			input.setAttribute('readonly', '');
			input.style.position = 'fixed';
			input.style.opacity = '0';
			document.body.appendChild(input);
			input.select();
			document.execCommand('copy');
			document.body.removeChild(input);
		}
		this.showNotification('Código de contador copiado.');
		this.copied = true;
		clearTimeout(this.copiedTimer);
		this.copiedTimer = setTimeout(() => { this.copied = false; }, 2000);
	} catch (error) {
		this.showNotification('No se pudo copiar el código de contador.', 'warning');
	}
}

function open(propTrue, propFalse) {
	this[propTrue] = true;
	this[propFalse] = false;
}

function data() {
	return {
		copied: false,
		copiedTimer: null,
		remoteLimit: undefined,
		showOne: true,
		showTwo: false,
	};
}

export default {
	name: 'step-question',
	computed: {
		accountantCode,
		allowedIds,
		limitReached,
		planLimit,
		disabledQuestion,
		...mapGetters('user', [
			'userAvatar',
			'userName',
		]),
		...mapGetters('subsidiary', [
			'currentSubsidiary',
			'getGlobalSubsidiaries',
		]),
	},
	created,
	data,
	methods: {
		copyAccountantCode,
		open,
		selectSubsidiary,
		...mapActions('user', {
			$clearUser: 'clearUser',
		}),
		...mapActions('subsidiary', {
			$setCurrentSubsidiary: 'setCurrentSubsidiary',
			$loadSubsidiaries: 'loadSubsidiaries',
		}),
	},
	props: {
		acceptDescription: {
			default: 'La contabilidad es una disciplina que se encarga de estudiar, medir y analizar el patrimonio y la situación económica financiera de una empresa u organización, con el fin de facilitar la toma de decisiones en el seno de la misma y el control externo, presentando la información, previamente registrada, de manera sistemática y útil para las distintas partes interesadas.',
			type: String,
		},
		acceptTitle: {
			default: 'INTEGRATE CON MAKIPOS',
			type: String,
		},
		negativeTitle: {
			default: 'YO LLEVO MI CONTABILIDAD',
			type: String,
		},
		openDialog: {
			default: false,
			type: Boolean,
		},
		question: {
			default: 'BIENVENIDO AL SISTEMA CONTABLE<br/>MAKIPOS!',
			type: String,
		},
		subsidiaryId: [Number, String],
		validIntegration: {
			default: true,
			type: Boolean,
		},
	},
};
</script>

<style lang="scss" scoped>
	.step-bottom__col {
		margin-bottom: 8px;
		min-width: 0;
		&:first-child { padding-right: 12px; }
	}
	.step-code-pill {
		align-items: center;
		background: #fff;
		border: 1px solid rgba(2, 151, 155, 0.35);
		border-radius: 999px;
		color: #02979b;
		cursor: pointer;
		display: flex;
		font-family: font(AvenirBold);
		font-size: 13px;
		gap: 8px;
		height: 38px;
		padding: 0 14px;
		transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
		width: 100%;
		&:hover { background: rgba(2, 151, 155, 0.08); border-color: rgba(2, 151, 155, 0.7); }
		&:active { transform: scale(0.99); }
		&:focus-visible { outline: 2px solid #02979b; outline-offset: 2px; }
		&--done {
			background: #02979b;
			border-color: #02979b;
			color: #fff;
			.step-code-icon, .step-code-action { color: #fff !important; }
		}
	}
	.step-code-icon { color: #02979b !important; flex: 0 0 auto; }
	.step-code-text { flex: 1 1 auto; text-align: left; }
	.step-code-action { color: rgba(15, 42, 68, 0.45) !important; flex: 0 0 auto; }
	.step-code-hint {
		color: rgba(15, 42, 68, 0.55);
		font-family: font(AvenirRegular);
		font-size: 12px;
		margin: 6px 0 0 4px;
	}
	.step-company-pill {
		align-items: center;
		background: #fff;
		border: 1px solid rgba(2, 151, 155, 0.35);
		border-radius: 999px;
		color: color(black);
		display: flex;
		font-family: font(AvenirBold);
		font-size: 13px;
		gap: 8px;
		height: 38px;
		min-width: 0;
		padding: 0 14px;
		transition: border-color 0.15s ease, box-shadow 0.15s ease;
		width: 100%;
		&:hover:not(:disabled) { border-color: rgba(2, 151, 155, 0.7); }
		&:focus-visible { outline: 2px solid #02979b; outline-offset: 2px; }
		&:disabled { background: rgba(15, 42, 68, 0.04); border-style: dashed; cursor: default; }
	}
	.step-company-icon { color: #02979b !important; flex: 0 0 auto; }
	.step-company-name {
		flex: 1 1 auto;
		min-width: 0;
		overflow: hidden;
		text-align: left;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.step-company-caret { color: rgba(15, 42, 68, 0.45) !important; flex: 0 0 auto; }
	.step-company-pill--empty .step-company-name {
		color: rgba(15, 42, 68, 0.45);
		font-family: font(AvenirRegular);
	}

	.step-question {
		padding: 10px 125px 80px;
		@media (max-width: 768px) {
			padding: 30px 0px 120px;
			width: auto;
		}
	}

	.title-question {
		color: #02979b !important;
		font-family: font(open-bold);
		font-size: 16px;
	}

	.color-btn {
		color: #02979b !important;
		font-family: font(open-bold) !important;
		background-color: PowderBlue !important;
		font-size: 14px !important;
		height: 40px !important;
		width: 130px !important;
	}

	.btn-selected {
		border: 1px solid color(primary);
		border-radius: 100%;
		box-shadow: none !important;
		color: #02979b !important;
		font-family: font(open-semibold);
		font-size: 18px;
		height: 64px !important;
		width: 64px !important;

		&.active {
			background-color: #02979b !important;
			box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15) !important;
			color: color(white) !important;
			font-family: font(open-bold);
			letter-spacing: 0px;
		}
	}

	.message-box {
		background-color: color(white);
  		box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.07);
		border-radius: 20px;
		border: PowderBlue 5px solid;
		font-family: font(open-bold);
		position: relative;
    	width: 100%;
		padding: 30px 39px;
	}

	.triangle {
		border-bottom: 26px solid rgba(0, 0, 0, 0.05);
		border-left: 8px solid transparent;
		border-right: 8px solid transparent;
		position: absolute;
		right: 117px;
		top: -26px;
		z-index: 1;

		&:before {
			border-bottom: 25px solid color(white);
			border-left: 7px solid transparent;
			border-right: 7px solid transparent;
			bottom: -26px;
			content: '';
			left: -7px;
			position: absolute;
		}

		&.active-two {
			right: 32px;
		}
	}
	.select {
		max-width: 250px;
	}

	.layout {
		position: relative;
	}

	.title-integration {
		color: #494949;
		font-family: font(open-bold);
		font-size: 16px;
	}

	.description {
		color: #909090;
		font-family: font(open-regular);
		font-size: 12px;
		width: 390px;
	}

	.video {
		// background-color: #f2f6f7;
		height: 202px;
		position: relative;
		overflow: hidden;
	}
	.video::after {
		content: "";
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 70px;
		background: linear-gradient(to top, rgba(255, 255, 255, 0.9), transparent);
		pointer-events: none;
	}

	.img-source {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	.title-warehouse {
		border-bottom: 1px solid #d2d2d2;
		color: #494949;
		font-family: font(open-bold);
		font-size: 16px;
		padding-bottom: 9px;
	}

	.dialog-contact {
		border-radius: 11px;
		box-shadow: 0 2px 13px 0 rgba(0, 0, 0, 0.13);
		padding: 35px 55px 60px 55px;
	}

	.btn-contact {
		background-color: #4caf50;
		border-radius: 5px;
		color: white;
		font-family: map-get($fonts, open-bold);
		font-size: 14px;
		padding: 9px;
	}

	.btn-close {
		background-color: transparent !important;
		position: absolute !important;
		right: 10px;
		top: 10px;
	}
</style>

<style lang="scss">
	// El activador del menú es inline-block y crece con el texto: se fija al
	// ancho de la columna para que el nombre largo se corte con "…".
	.step-company-menu-wrap,
	.step-company-menu-wrap .v-menu__activator {
		display: block !important;
		max-width: 100%;
		min-width: 0;
		width: 100%;
	}

	// El menú se dibuja fuera del componente (no usa attach para no quedar
	// recortado por el stepper), por eso estos estilos no son scoped.
	.step-company-menu {
		background: #fff;
		border: 1px solid rgba(15, 42, 68, 0.08);
		border-radius: 14px !important;
		box-shadow: 0 18px 38px rgba(15, 42, 68, 0.16) !important;
		.step-company-list {
			background: #fff !important;
			padding: 8px !important;
		}
		.step-company-limit {
			align-items: flex-start;
			background: rgba(255, 179, 0, 0.12);
			border-radius: 10px;
			color: #8a5a00;
			display: flex;
			font-family: font(AvenirRegular);
			font-size: 12px;
			gap: 8px;
			line-height: 1.4;
			margin-bottom: 8px;
			padding: 10px 12px;
			.v-icon { color: #c98400 !important; flex: 0 0 auto; margin-top: 1px; }
		}
		.step-company-option {
			border-radius: 10px;
			margin-bottom: 2px;
			.v-list__tile {
				align-items: center;
				border-radius: 10px;
				display: flex;
				gap: 12px;
				height: auto !important;
				min-height: 42px;
				padding: 8px 14px !important;
				transition: background-color 0.15s ease;
			}
			.v-icon { color: rgba(15, 42, 68, 0.45) !important; flex: 0 0 auto; }
			&:hover .v-list__tile { background: rgba(2, 151, 155, 0.08); }
		}
		.step-company-option-name {
			color: color(black);
			flex: 1 1 auto;
			font-family: font(AvenirRegular);
			font-size: 13px;
			line-height: 1.3;
			min-width: 0;
			overflow-wrap: anywhere;
			text-transform: uppercase;
			white-space: normal;
		}
		.step-company-option--active {
			.v-list__tile { background: rgba(2, 151, 155, 0.12); }
			.step-company-option-name { color: #02979b; font-family: font(AvenirBold); }
			.v-icon { color: #02979b !important; }
		}
		.step-company-option--locked {
			.v-list__tile { cursor: not-allowed; }
			.step-company-option-name { color: rgba(15, 42, 68, 0.4); }
			.v-icon { color: rgba(15, 42, 68, 0.3) !important; }
			&:hover .v-list__tile { background: transparent; }
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/accountant/step-question.vue